<!-- TODO: Refactor the logic to auto place the datepicker automatically based on screen size and current viewport position -->
@if (!isButtonIntervalSelector) {
  <div class="date-filter">
    <div class="dropdown">

      <!-- TOP placement -->
      @if (showDatePicker && isDatePickerTop) {
        <ng-container [ngTemplateOutlet]="datePickerTpl"></ng-container>
      }

      <input
        type="text"
        [ngClass]="{'custom-range': isCustomDate}"
        class="form-control dropdown-toggle search-input"
        aria-label="Search"
        [attr.aria-expanded]="isDropdownOpen"
        placeholder="1 Month"
        [(ngModel)]="intervalLabel"
        readonly
        (click)="toggleDropdown($event)" />

      <i class="ph ph-caret-down lh-base caret-input"></i>

      <div class="dropdown-menu w-100" [class.show]="isDropdownOpen">
        @for (option of dateIntervalDropdownOptions; track option.label) {
          <span>
            <button class="dropdown-item" (click)="selectInterval(option.value)">
              {{ option.label }}
            </button>
          </span>
        }

        @if (!disableCustomDateSelector) {
          <span>
            <button class="dropdown-item custom-date-item" (click)="toggleDatePicker()">
              <span>Custom date</span>
              <i class="ph-duotone ph-calendar-dots"></i>
            </button>
          </span>
        }
      </div>

      <!-- BOTTOM placement -->
      @if (showDatePicker && !isDatePickerTop) {
        <ng-container [ngTemplateOutlet]="datePickerTpl"></ng-container>
      }

      <ng-template #datePickerTpl>
        <div
          class="datepicker-container"
          [ngClass]="{ 'placement-top': isDatePickerTop, 'placement-bottom': !isDatePickerTop }">
          <app-flatpickr-date-picker
            [inline]="true"
            [mode]="'range'"
            [showMonths]="2"
            [maxDate]="'today'"
            (rangeSelected)="onRangeSelected($event)"
            (rangeClear)="onRangeClear()">
          </app-flatpickr-date-picker>
        </div>
      </ng-template>

    </div>
  </div>
}

<!-- TODO: Refactor the logic to auto place the datepicker automatically based on screen size and current viewport position -->
@if (isButtonIntervalSelector) {
  <div class="button-date-filter">
    <div class="d-flex align-items-center date-selector-container gap-2" role="group">

      <!-- TOP placement -->
      @if (showDatePicker && isDatePickerTop) {
        <ng-container [ngTemplateOutlet]="datePickerTplBtn"></ng-container>
      }

      @for (option of dateIntervalButtons; track option.label) {
        <button
          type="button"
          class="btn btn-outline-secondary date-selector"
          (click)="selectInterval(option.value)"
          [ngClass]="{'active': filter.interval === option.value && !isCustomDateSelected}"
          [class.disabled]="filter.interval === option.value && !isCustomDateSelected"
          [disabled]="filter.interval === option.value && !isCustomDateSelected">
          {{ option.label }}
        </button>
      }

      @if (!disableCustomDateSelector) {
        <button
          class="btn btn-outline-light rounded date-selector date-selector-calendar"
          (click)="toggleShowDatePicker($event)"
          [ngClass]="{'active': isCustomDateSelected}">
          <i class="custom_calender_icon ph-duotone ph-calendar-dots float-end"></i>
        </button>
      }

      <!-- BOTTOM placement -->
      @if (showDatePicker && !isDatePickerTop) {
        <ng-container [ngTemplateOutlet]="datePickerTplBtn"></ng-container>
      }

      <ng-template #datePickerTplBtn>
        <div
          class="datepicker-container"
          [ngClass]="{ 'placement-top': isDatePickerTop, 'placement-bottom': !isDatePickerTop }">
          <app-flatpickr-date-picker
            [inline]="true"
            [mode]="'range'"
            [showMonths]="2"
            [maxDate]="'today'"
            (rangeSelected)="onRangeSelected($event)"
            (rangeClear)="onRangeClear()">
          </app-flatpickr-date-picker>
        </div>
      </ng-template>

    </div>
  </div>
}